/**
 * Created by netre on 27.06.2017.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';
import { translate } from 'react-i18next';
import Support from './Support';
import { Languages } from './Languages';

@translate(['common'], { wait: true })
export class SidebarFooter extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="copyright">
        <Languages />
        <div className="holder">
          <div>
            © {moment().year()} {t('common:appName')}
          </div>
          <div>
            <Support />
            <a
              href="http://smartdriving.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Smartdriving.io
            </a>
          </div>
        </div>
      </div>
    );
  }
}

SidebarFooter.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarFooter/index.js